module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp23_3009.342c8a07.png";